module.exports = __webpack_public_path__ + "img/saemidori-h.0f369b8e.jpg";